import { localStg } from '@/utils/storage/local';
import { EnumLocalStore } from '@/constant/enums';

export const envConfig = {
    deployType: process.env.VUE_APP_DEPLOY_TYPE,
    cnApi: process.env.VUE_APP_CN_API,
    overseaApi: process.env.VUE_APP_OVERSEA_API,
    getCurrentApi: () => {
        let region = localStg.get(EnumLocalStore.region);
        if (!region) {
            return envConfig.cnApi;
        }
        return region.toLocaleLowerCase() === 'oversea' ? envConfig.overseaApi : envConfig.cnApi;
    }
}

